/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from 'Presentation/Views/Auth'
import { useCookies } from 'react-cookie'
import { useAuthSessionStore } from 'Store/AuthSession'
import { App } from '../App'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
	const [cookies] = useCookies(['kumopack-supplier-access-token'])
	const accessToken = cookies['kumopack-supplier-access-token']
	const { sessionAccessToken } = useAuthSessionStore(state => ({
		sessionAccessToken: state.accessToken,
	}))

	const isRemember = accessToken ? true : false

	return (
		<BrowserRouter basename={PUBLIC_URL}>
			<Routes>
				<Route element={<App />}>
					<Route path="logout" element={<Logout />} />
					{(isRemember ? accessToken : sessionAccessToken) ? (
						<React.Fragment>
							<Route path="auth" element={<Navigate to="dashboard" />} />
							<Route path="*" element={<PrivateRoutes />} />
							<Route index element={<Navigate to="/dashboard" replace />} />
						</React.Fragment>
					) : (
						<React.Fragment>
							<Route path="auth/*" element={<AuthPage />} />
							<Route
								path="*"
								element={
									<Navigate
										to="/auth"
										state={{
											prevPage: window.location.pathname + (window.location.search ?? ''),
										}}
										replace
									/>
								}
							/>
						</React.Fragment>
					)}
				</Route>
			</Routes>
		</BrowserRouter>
	)
}

export { AppRoutes }
